<template lang="pug">
  .map-wrap(
    @click="handleMapClick")
    iframe(
      width="100%"
      height="250"
      frameborder="0"
      :style="{ border:0, pointerEvents: mapScrollable ? 'auto' : 'none' }"
      :src="query"
      allowfullscreen)
</template>
<script>
import { getBoundaryBox, } from '../../../utils/maps'

function getAddressCoords () {
  this.center = {
    lat: parseFloat(this.response[0].lat),
    lon: parseFloat(this.response[0].lon),
  }
}

function handleMapClick () {
  this.mapScrollable = true
}

export default {
  props: {
    address: {
      type: Object,
      required: true,
    },
    response: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      center: {
        lat: 0,
        lon: 0,
      },
      mapScrollable: false,
    }
  },
  computed: {
    query () {
      const base = 'https://www.openstreetmap.org/export/embed.html'
      const center = this.center.lat + ',' + this.center.lon
      const bbox = getBoundaryBox(this.center.lat, this.center.lon, 100)
      return `${base}?bbox=${bbox}&marker=${center}`
    },
  },
  created () {
    getAddressCoords.call(this)
  },
  methods: {
    getAddressCoords,
    handleMapClick,
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../../assets/styles/variables.styl"

  .map-wrap
    margin-bottom 2px
    z-index 10
  .address-map
    width 100%
    height 300px

  @media (max-width: $tablet)
    .address-map
      height 250px
    .map-wrap
      margin 5px 0
</style>



// WEBPACK FOOTER //
// src/components/record-details/address/AddressMap.vue